module.exports = __webpack_public_path__ + "static/media/img76_R.410e765d.jpg";